import React from 'react'
export default function Yandex({ className, style }) {
  return (
    <svg className={className} width="1em" height="1em" style={{ verticalAlign: '-0.125em', ...style }}
      viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <path d="M14.5 18V6h-2a2.5 2.5 0 0 0 0 5h2" />
      <path d="M13 11l-2.5 7" />
    </svg>
  )
}
